import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MojoNotesService } from 'mojo-irp-notes/lib/mojo-notes.config';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import {
  NOTES_FILTERS_PARAMS_DEFAULT_PAGE_SIZE,
  NotesFiltersInterface,
} from '@modules/notes/filters-store/notes-filters.service';
import { Pagination } from '@shared/pagination';

import { Note, NoteSubject, PersistedNote } from 'mojo-irp-notes';
import { NotePageTypeEnum } from '@modules/notes/models/note-page-type.enum';

@Injectable({ providedIn: 'root' })
export class NoteService implements MojoNotesService {
  private url = environment.API_BASE_URL + '/notes/';

  constructor(private readonly http: HttpClient) {}

  getNotes(notesFilters: NotesFiltersInterface): Observable<Pagination<Note>> {
    const pathParams = this.getParams(notesFilters);
    const params = {
      userGenerated: notesFilters.userGenerated ? 'true' : 'false',
      systemGenerated: notesFilters.systemGenerated ? 'true' : 'false',
      pageSize: NOTES_FILTERS_PARAMS_DEFAULT_PAGE_SIZE.toString(),
      pageNumber: notesFilters.pageNumber?.toString(),
      anonymised: notesFilters.anonymised ? 'true' : 'false',
      search: notesFilters.searchPhrases.length > 0 ? notesFilters.searchPhrases.toString() : '',
    };

    // TODO: MOJAT-4131 when turning on the notes for HM make sure pathParams.subjectTypeId is not undefined
    return this.http.get(`${this.url}${pathParams.subjectType}/${pathParams.subjectTypeId}`, {
      params,
    });
  }

  createNote(note: Note, notesFilters?: NotesFiltersInterface): Observable<Note> {
    const pathParams = notesFilters
      ? this.getParams(notesFilters)
      : {
          subjectType: note.subjectType,
          subjectTypeId: String(note.subjectId),
        };

    return this.http.post<Note>(
      `${this.url}${pathParams.subjectType}/${pathParams.subjectTypeId}`,
      note,
    );
  }

  patchNote(note: PersistedNote): Observable<Note> {
    return this.http.patch<Note>(
      `${this.url}${note.subjectType}/${note.subjectId}/${note.id}`,
      note,
    );
  }

  archive(note: PersistedNote): Observable<Note> {
    return this.http.patch<Note>(`${this.url}${note.id}/archive`, {});
  }

  private getParams(notesFilters: NotesFiltersInterface) {
    let subjectType;
    if (notesFilters.id.includes(NotePageTypeEnum.JOB)) {
      subjectType = notesFilters.isForHiringTeamTab
        ? NoteSubject.JobHiringManager
        : NoteSubject.Job;
    } else if (notesFilters.id.includes(NotePageTypeEnum.TALENT_POOL)) {
      subjectType = NoteSubject.TalentPool;
    } else if (notesFilters.id.includes(NotePageTypeEnum.CANDIDATE)) {
      subjectType = NoteSubject.Candidate;
    }

    const subjectTypeId = notesFilters.subjectId;
    return { subjectType, subjectTypeId };
  }
}
